import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import './styles/index.scss';
import 'vant/lib/index.css';
import router from '@/router';

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

app.use(router);

app.mount('#root');
